import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";

import { palette, typography, shadows } from "../../theme/brand";

// Own team-member card, built from scratch on the brand tokens. Replaces the
// template `Card` / `CardAvatar` / `CardBody` trio previously used by SectionTeam.
const styles = {
  card: {
    backgroundColor: palette.surface,
    borderRadius: "16px",
    boxShadow: shadows.card,
    padding: "32px 24px",
    textAlign: "center",
    height: "100%",
    boxSizing: "border-box",
    transition: "transform 0.25s ease, box-shadow 0.25s ease",
    "&:hover": {
      transform: "translateY(-6px)",
      boxShadow: shadows.cardHover
    }
  },
  avatarWrap: {
    width: "130px",
    height: "130px",
    margin: "0 auto 20px",
    borderRadius: "50%",
    padding: "4px",
    background: `linear-gradient(135deg, ${palette.primary}, ${palette.accent})`
  },
  avatar: {
    width: "100%",
    height: "100%",
    borderRadius: "50%",
    objectFit: "cover",
    display: "block",
    border: `3px solid ${palette.surface}`
  },
  name: {
    color: palette.textPrimary,
    fontFamily: typography.fontFamilyDisplay,
    fontWeight: 700,
    fontSize: "1.25rem",
    margin: "0 0 6px"
  },
  role: {
    color: palette.secondary,
    fontFamily: typography.fontFamilyBase,
    fontWeight: 600,
    fontSize: "0.95rem",
    letterSpacing: "0.3px",
    margin: 0
  }
};

function TeamMemberCard({ classes, photo, name, role }) {
  return (
    <div className={classes.card}>
      <div className={classes.avatarWrap}>
        <img src={photo} alt={name} className={classes.avatar} />
      </div>
      <h4 className={classes.name}>{name}</h4>
      <p className={classes.role}>{role}</p>
    </div>
  );
}

TeamMemberCard.propTypes = {
  classes: PropTypes.object.isRequired,
  photo: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired
};

export default withStyles(styles)(TeamMemberCard);



// WEBPACK FOOTER //
// ./src/components/ui/TeamMemberCard.jsx